import { LoadingButton } from '@mui/lab';
import {
  Autocomplete,
  Box,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useLocationList from 'api/homePage/useLocationList/useLocationList';
import useLocationZone from 'api/locationZone/useLocationZone/useLocationZone';
import PageSpinner from 'components/shared/pageSpinner/PageSpinner';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import React, { useEffect, useState } from 'react';

const ConvertUserToAgentModal = ({
  open,
  handleClose,
  convertToAgentLoading,
  onConvertToAgent,
}) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);

  const [getLocationList, locationsLoading, locationList] = useLocationList({
    notTable: true,
  });
  const [getZonesList, zonesLoading, zonesList] = useLocationZone();

  const onClose = () => {
    setSelectedLocation(null);
    setSelectedZone(null);
    handleClose();
  };

  useEffect(() => {
    if (open) {
      getLocationList();
    } else {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (selectedLocation?.key) {
      getZonesList({}, { notTable: true, locationGuid: selectedLocation?.key });
    } else {
      setSelectedZone(null);
    }
  }, [selectedLocation]);

  const onSubmit = () => {
    if (selectedLocation && selectedZone) {
      onConvertToAgent({
        zoneGUID: selectedZone?.key,
      });
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>تبدیل کاربر به ایجنت</DialogTitle>

      <DialogContent sx={{ minWidth: '360px' }}>
        {locationsLoading ? (
          <SpinnerLoader loading={locationsLoading} />
        ) : (
          <Stack gap={2}>
            <p className="text-sm text-gray-500">
              لطفا انبار و سالن فعالیت ایجنت را انتخاب کنید
            </p>

            <Box sx={{ width: '360px' }}>
              <Autocomplete
                options={locationList || []}
                autoHighlight
                disableClearable
                loading={locationsLoading}
                value={selectedLocation || null}
                getOptionLabel={option => option.value}
                noOptionsText={
                  <div className="w-full flex justify-center">
                    موردی یافت نشد
                  </div>
                }
                renderOption={(args, option) => (
                  <div {...args} dir="rtl">
                    {option.value}
                  </div>
                )}
                onChange={(event, newValue) => {
                  setSelectedLocation(prev => newValue);
                }}
                sx={{
                  '.MuiInputBase-root': {
                    paddingRight: '9px !important',
                  },
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    sx={{
                      '.MuiAutocomplete-endAdornment': {
                        right: 'unset !important',
                        left: '9px',
                      },
                      '.MuiAutocomplete-endAdornment button': {
                        mr: 0.5,
                      },
                    }}
                    label="انتخاب انبار پیش‌فرض"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'zone', // disable autocomplete and autofill
                    }}
                    className="gray-icon"
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
            </Box>

            <Box sx={{ width: '360px' }}>
              <Autocomplete
                options={zonesList || []}
                autoHighlight
                disableClearable
                disabled={!selectedLocation}
                loading={zonesLoading}
                value={selectedZone || null}
                getOptionLabel={option => option.value}
                noOptionsText={
                  <div className="w-full flex justify-center">
                    {zonesLoading ? (
                      <PageSpinner loading={zonesLoading} />
                    ) : (
                      'موردی یافت نشد'
                    )}
                  </div>
                }
                renderOption={(args, option) => (
                  <div {...args} dir="rtl">
                    {option.value}
                  </div>
                )}
                onChange={(event, newValue) => {
                  setSelectedZone(prev => newValue);
                }}
                sx={{
                  '.MuiInputBase-root': {
                    paddingRight: '9px !important',
                  },
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    sx={{
                      '.MuiAutocomplete-endAdornment': {
                        right: 'unset !important',
                        left: '9px',
                      },
                      '.MuiAutocomplete-endAdornment button': {
                        mr: 0.5,
                      },
                    }}
                    label="انتخاب سالن پیش‌فرض"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'zone', // disable autocomplete and autofill
                    }}
                    className="gray-icon"
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
            </Box>
          </Stack>
        )}
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={convertToAgentLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          color="warning"
          variant="contained"
          onClick={onSubmit}
          loading={convertToAgentLoading}
          disabled={!selectedLocation || !selectedZone}
        >
          ذخیره
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConvertUserToAgentModal;
